import { render, staticRenderFns } from "./TakeOrUploadPictureModal.vue?vue&type=template&id=f166710a&scoped=true&"
import script from "./TakeOrUploadPictureModal.vue?vue&type=script&lang=js&"
export * from "./TakeOrUploadPictureModal.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrUploadPictureModal.vue?vue&type=style&index=0&id=f166710a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f166710a",
  null
  
)

export default component.exports